export const MIN_MAIN_PANE_WIDTH_PERCENT = 40;
export const MIN_SIDEBAR_WIDTH_PERCENT = 15;
export const MAX_SIDEBAR_WIDTH_PERCENT = 90;

const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

export const clampSidebarWidthPercent = ({
  nextWidthPercent,
  otherSidebarOpen,
  otherSidebarWidthPercent,
}) => {
  const otherWidth = otherSidebarOpen ? otherSidebarWidthPercent : 0;
  const maxWidth = clamp(
    100 - MIN_MAIN_PANE_WIDTH_PERCENT - clamp(otherWidth, 0, 100),
    0,
    MAX_SIDEBAR_WIDTH_PERCENT
  );
  const minWidth = Math.min(MIN_SIDEBAR_WIDTH_PERCENT, maxWidth);

  return clamp(nextWidthPercent, minWidth, maxWidth);
};
